module.exports = ".labelButton {\r\n    padding: 5px;\r\n    font-size: 0.8rem;\r\n    border: 1px solid lightgrey;\r\n    text-align: center;\r\n    cursor: default;\r\n    color: rgba(0, 0, 0, 0.42);\r\n    background-color: rgba(224, 224, 224, 0.42);\r\n}\r\n\r\n.labelButtonActive {\r\n    cursor: pointer;\r\n    color: rgba(0, 0, 0, 0.87);\r\n    background-color: rgba(224, 224, 224, 1);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/label-button.css
// module id = 270
// module chunks = 1